const DESKTOP_LINK_REDIRECT_STORAGE_KEY = "qflow_desktop_link_redirect";
const DESKTOP_LINK_REDIRECT_MAX_AGE_MS = 15 * 60 * 1000;
const WINDOW_NAME_PREFIX = "__qflow_desktop_link_redirect__:";

function isSafeDesktopLinkRedirect(value) {
  return typeof value === "string" && value.startsWith("/desktop-link");
}

function buildRedirectRecord(redirect) {
  return JSON.stringify({
    redirect,
    saved_at: Date.now(),
  });
}

function parseRedirectRecord(raw) {
  if (!raw) {
    return "";
  }
  try {
    const parsed = JSON.parse(raw);
    const redirect = parsed?.redirect;
    const savedAt = Number(parsed?.saved_at || 0);
    const isFresh = savedAt > 0 && Date.now() - savedAt <= DESKTOP_LINK_REDIRECT_MAX_AGE_MS;
    return isFresh && isSafeDesktopLinkRedirect(redirect) ? redirect : "";
  } catch {
    return "";
  }
}

function writeWindowNameRedirect(record) {
  try {
    window.name = `${WINDOW_NAME_PREFIX}${record}`;
  } catch {
    // Best effort only; local/session storage are the primary stores.
  }
}

function readWindowNameRedirect() {
  try {
    const name = String(window.name || "");
    if (!name.startsWith(WINDOW_NAME_PREFIX)) {
      return "";
    }
    return parseRedirectRecord(name.slice(WINDOW_NAME_PREFIX.length));
  } catch {
    return "";
  }
}

function clearWindowNameRedirect() {
  try {
    if (String(window.name || "").startsWith(WINDOW_NAME_PREFIX)) {
      window.name = "";
    }
  } catch {
    // Nothing to clear.
  }
}

export function saveDesktopLinkRedirect(redirect) {
  if (!isSafeDesktopLinkRedirect(redirect) || typeof window === "undefined") {
    return false;
  }
  const record = buildRedirectRecord(redirect);
  window.localStorage.setItem(DESKTOP_LINK_REDIRECT_STORAGE_KEY, record);
  window.sessionStorage.setItem(DESKTOP_LINK_REDIRECT_STORAGE_KEY, record);
  writeWindowNameRedirect(record);
  return true;
}

export function getDesktopLinkRedirect() {
  if (typeof window === "undefined") {
    return "";
  }
  return parseRedirectRecord(window.sessionStorage.getItem(DESKTOP_LINK_REDIRECT_STORAGE_KEY))
    || parseRedirectRecord(window.localStorage.getItem(DESKTOP_LINK_REDIRECT_STORAGE_KEY))
    || readWindowNameRedirect();
}

export function clearDesktopLinkRedirect() {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.removeItem(DESKTOP_LINK_REDIRECT_STORAGE_KEY);
  window.sessionStorage.removeItem(DESKTOP_LINK_REDIRECT_STORAGE_KEY);
  clearWindowNameRedirect();
}

export function consumeDesktopLinkRedirect() {
  const redirect = getDesktopLinkRedirect();
  clearDesktopLinkRedirect();
  return redirect;
}

export function hasDesktopLinkRedirect() {
  return Boolean(getDesktopLinkRedirect());
}
